import { useSelector, useDispatch } from 'react-redux'

import { loadMoreData } from 'actions/home_bar/scope_dropdown'
import {
  isFilteringSelector,
  filterTermSelector,
  usersSelector,
  hasMoreUsersSelector
} from 'selectors/home_bar'

import AllScope from './all_scope'
import Header from './header'
import Item from './item'
import MenuGroup from './menu_group'
import ShowMore from './show_more'

const UsersList = ({ shouldShowAll, selectItem, canManageInvitation }) => {
  const dispatch = useDispatch()
  const isFiltering = useSelector(isFilteringSelector)
  const filterTerm = useSelector(filterTermSelector)
  const users = useSelector(usersSelector)
  const hasMoreUsers = useSelector(hasMoreUsersSelector)
  const showHeader = !isFiltering || users.length > 0
  const showAllScope = shouldShowAll && !isFiltering

  return (
    <MenuGroup data-component="scope-dropdown-user-list">
      {showHeader && (
        <Header
          scope="user"
          showNewLink={canManageInvitation}
        />
      )}
      {showAllScope && (
        <AllScope
          scope="all_users"
          onClick={() => selectItem('all_users')}
        />
      )}
      {users.map(({ id, name, ...item }) => (
        <Item
          key={id}
          itemId={id}
          avatarLetter={item.avatar_letter}
          avatarUrl={item.avatar_url}
          onClick={() => selectItem('user_single', id)}
          filterTerm={filterTerm}
        >
          {name}
        </Item>
      ))}
      {hasMoreUsers && <ShowMore onClick={() => dispatch(loadMoreData('users'))} />}
    </MenuGroup>
  )
}

export default UsersList
